module.exports = __webpack_public_path__ + "static/media/bdo-sandybay.048caa07.jpg";